module.exports = __webpack_public_path__ + "static/media/item_23_6_comp.94dc191e.png";